import React, { useState, useEffect } from "react";
import "./css/styles.css";
import { DataGrid } from "@mui/x-data-grid";
import {
  Card,
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  TextField,
  FormControl,
  Box,
  Modal,
} from "@mui/material";
import PortraitIcon from "@mui/icons-material/Portrait";
import { modalstyle, muiAbtn, starIcon } from "./style";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import AddIcon from "@mui/icons-material/Add";
import Rating from "@mui/material/Rating";
import CreativeImage from "./CreativeImage";
import {
  collection,
  getDocs,
  setDoc,
  addDoc,
  updateDoc,
  doc,
  query,
  orderBy,
  deleteDoc,
  limit,
  where,
  getDoc,
} from "firebase/firestore";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { db } from "../firebase";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "#fff",
  boxShadow: 24,
  p: 4,
  boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
};

export default function UserReviews() {
  const [rows, setRows] = useState([]);
  const [Review, setReview] = useState("");
  const [loading, setLoading] = useState(false); ///To check if data if loaded or not from collection.
  const [rowId, setrowId] = useState(-1);

  useEffect(() => {
    let active = true;
    const getData = async () => {
      setLoading(true);
      /////Getting the latest document first.
      const data = await getDocs(
        query(collection(db, "reviews"), orderBy("time", "desc"))
      );
      //////Mapping Through App Documents And Then Saving them in rows useState.
      data.docs.map((document) => {
        setRows((row) => [
          ...row,
          {
            ...document.data(),
            id: document.id,
          },
        ]);
      });

      if (!active) {
        return;
      }

      setLoading(false);
      return () => {
        active = false;
      };
    };
    getData();
  }, []);
  const [open, setOpen] = useState(false);
  const [UnaprovedID, setUnaprovedID] = useState("");

  const handleOpen = (index) => {
    setrowId(index);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpen = (id) => {
    setOpenDialog(true);
    setUnaprovedID(id);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setUnaprovedID("");
  };

  const approveReview = (id) => {
    updateDoc(doc(db, "reviews", id), { status: "Approved" }).then(() => {
      toast.success("Review Approved");

      setRows(
        rows.map((item) => {
          if (item.id === id) {
            return { ...item, status: "Approved" };
          } else {
            return item;
          }
        })
      );
    });
  };
  const rejectReview = () => {
    updateDoc(doc(db, "reviews", UnaprovedID), { status: "Unapproved" }).then(
      () => {
        toast.info("Review Unapproved");
        handleCloseDialog();

        setRows(
          rows.map((item) => {
            if (item.id === UnaprovedID) {
              return { ...item, status: "Unapproved" };
            } else {
              return item;
            }
          })
        );
      }
    );
  };

  const columns = [
    // { field: "id", headerName: "ID", width: "60" },
    {
      field: "comments",
      headerName: "",
      width: "300",
      align: "left",
    },

    {
      field: "rating",
      headerName: "",
      width: "200",
      align: "center",
      renderCell: (params) => {
        return (
          <>
            <Rating
              name="half-rating-read"
              defaultValue={params.row.ratting}
              // defaultValue={params.row.rating}
              precision={0.5}
              readOnly
            />
          </>
        );
      },
    },
    {
      field: "status",
      headerName: "",
      width: "120",
      align: "center",
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   width: "120",
    // },
    {
      field: "Action",
      width: "330",
      align: "right",

      editable: false,
      renderCell: ActionButton,
    },
  ];

  function ActionButton(params) {
    return (
      <>
        {/* <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          startIcon={<RemoveRedEyeIcon />}
          onClick={() => handleOpen(params.row.index)}
        >
          View
        </Button> */}

        <Button
          variant="contained"
          color="primary"
          style={muiAbtn}
          size="small"
          // startIcon={<CheckCircleIcon />}
          onClick={() => approveReview(params.row.id)}
        >
          Approve
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="small"
          style={muiAbtn}
          onClick={() => handleClickOpen(params.row.id)}
          // startIcon={<CancelIcon />}
        >
          Unapprove
        </Button>
      </>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        padding: 40,
        paddingRight: 20,

        backgroundColor: "#212C62",
      }}
    >
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Are you sure to Unapprove the Review?"}
        </DialogTitle>

        <DialogActions>
          <Button onClick={() => rejectReview()}>Yes</Button>
          <Button onClick={handleCloseDialog} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Card style={{ padding: 50, borderRadius: 10 }}>
        <div className="row d-flex justify-content-between">
          <div className="col-6">
            <h1
              className="mb-4 py-4"
              style={{ textAlign: "left", color: "#212C62" }}
            >
              <b>All Reviews</b>
            </h1>
          </div>
          <div
            className="col-6 d-flex justify-content-end"
            style={{ marginTop: "-30px" }}
          >
            <CreativeImage />
          </div>
        </div>
        <div className="mt-2">
          <h5 style={{ color: "212C62" }}>
            <b>All Reviews</b>
          </h5>
          <DataGrid
            style={{ height: "65vh", width: "100%" }}
            columns={columns}
            rows={rows}
            // getRowId={(Rows) => Rows._id}
            pageSize={6}
            rowsPerPageOptions={[5]}
            loading={loading}
            disableColumnMenu={true}
            headerHeight={0}
            disableSelectionOnClick
            getRowSpacing={(params) => ({
              top: params.isFirstVisible ? 10 : 8,
              bottom: params.isLastVisible ? 0 : 8,
            })}
          />
        </div>
      </Card>
    </div>
  );
}
